export enum Role {
  ADMIN = "ADMIN",
  USER = "USER",
  READ_ONLY = "READ_ONLY",
}
